import {UserManagerSettings} from 'oidc-client-ts';

// export const HOST = "http://10.10.10.251:8090";

export const HOST = import.meta.env.VITE_API_HOST ?? 'https://case-api-online-uat.nobula.eu';
export const MAIL_TO = 'info@nobula.eu';
export const MEDIA_HOST = 'http://localhost:8082';
export const PRESENTER_QUERY_PARAM = 'presenterCode';
export const REDIRECT_KEY = 'ncc-oidc-redirect';
export const PRESENTATION_ENDED_EVENT = 'incase-presentation-ended';
export const JS_INTERACTABLE_ELEMENT = 'js-interactable-element';

export const DEFAULT_NUMBER_OF_RETRIES = 2;

export const MAX_IMG_SIZE = 500 * 1024;

export const WORKSPACE_SIZE_DEFAULT = {
    width: 1360,
    height: 760,
};

export const HEX_SECONDARY_COLOR = '#5611a5';
export const SHAPE_COLOR_DEFAULT = '#494949';
export const TOOLTIP_DELAY = 500;

export const AAIEDUEnv: UserManagerSettings = {
    metadataUrl: import.meta.env.VITE_AAIEDU_META_URL,
    authority: import.meta.env.VITE_AAIEDU_AUTHORITY_URL,
    client_id: import.meta.env.VITE_AAIEDU_CLIENT_ID,
    scope: import.meta.env.VITE_AAIEDU_CLIENT_SCOPE,
    redirect_uri: import.meta.env.VITE_AAIEDU_REDIRECT_URL,
    response_type: 'code',
    disablePKCE: true,
};

export const ZoomEnv = {
    client_id: import.meta.env.VITE_ZOOM_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_ZOOM_REDIRECT_URL,
};

export const EmedikusEnv = {
    issuer_url: import.meta.env.VITE_EMEDIKUS_ISSUER_URL,
    client_id: import.meta.env.VITE_EMEDIKUS_CLIENT_NAME || import.meta.env.VITE_EMEDIKUS_CLIENT_ID || '',
    redirect_uri: import.meta.env.VITE_EMEDIKUS_REDIRECT_URI,
};
